var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromptMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.097,
    height: 21.097,
    viewBox: "0 0 21.097 21.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(-1532.412 -676.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Close-Square",
    "data-name": "Iconly/Bold/Close-Square",
    transform: "translate(1532.412 676.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close-Square",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M15.127,0C18.7,0,21.1,2.511,21.1,6.245h0v8.619c0,3.724-2.395,6.233-5.971,6.233H5.981C2.405,21.1,0,18.588,0,14.864H0V6.245C0,2.511,2.405,0,5.981,0h9.146Z",
    transform: "translate(0 0)",
    fill: "#ffb109"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(1547.899 692.476)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.588,
    y: 0
  }, "?")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptMark);
export default __webpack_public_path__ + "static/media/Prompt-mark.94e2818a5054640eceb67b2e1530b021.svg";
export { ForwardRef as ReactComponent };